import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=0f4dbe80&scoped=true"
import script from "./Opening.vue?vue&type=script&lang=js"
export * from "./Opening.vue?vue&type=script&lang=js"
import style0 from "./Opening.vue?vue&type=style&index=0&id=0f4dbe80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4dbe80",
  null
  
)

export default component.exports